import {loading, stopLoading} from "../../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {handleAjaxSuccess} from "../../../helpers/swalHelper";
import {ManageMediaModal} from "./ManageMediaModal/ManageMediaModal";

function initProductionAuditionConfimSubmissionIndex() {

	// Setup submit button
	const submitButton = document.querySelector('.continue-button')
	submitButton.addEventListener('click', handleContinueRequest)

	// Setup role checkbox and select
	const welcomeEmailCheckbox = document.querySelector('input[name="send_welcome_email"]');
	const virtualAuditionEmailCheckbox = document.querySelector('input[name="send_virtual_audition_email"]');

	const manageMediaButton = document.querySelector('.manage-photos-button');
	if (manageMediaButton) {
		manageMediaButton.addEventListener('click', () => {
			displayManageMediaModal()
		});
	}


	/** Methods */

	function handleContinueRequest() {

		const data = {
			is_welcome_email_checked: welcomeEmailCheckbox ? welcomeEmailCheckbox?.checked : false,
			is_virtual_email_checked: virtualAuditionEmailCheckbox ? virtualAuditionEmailCheckbox?.checked : false,
		};

		loading();

		Axios.post(submitButton.dataset.route, data)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)

	}

	function displayManageMediaModal() {
		const modal = new ManageMediaModal({
			modalContainer: document.querySelector('.manage-media-modal'),
		})

		modal.display(true);
	}

}

export {
	initProductionAuditionConfimSubmissionIndex
}
